var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"va-app",class:_vm.isSigninRoute()},[_c('navigation'),_vm._v(" "),_c('div',{staticClass:"va-container"},[_c('div',{staticClass:"va-content"},[_c('router-view')],1),_vm._v(" "),_c('page-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }